export type LinkItem = {
    href: string;
    label: string;
    target?: React.HTMLAttributeAnchorTarget;
};

export const popularLinks: LinkItem[] = [
    {
        label: "Tuition",
        href: "https://www.imgacademy.com/boarding-school/academics/tuition",
    },
    {
        label: "Accommodations & travel",
        href: "https://www.imgacademy.com/accommodations-and-travel",
    },
    {
        label: "About us",
        href: "https://www.imgacademy.com/about-img-academy",
    },
    {
        label: "Careers",
        href: "https://www.imgacademy.com/about-img-academy/careers",
    },
    {
        label: "Foundation",
        href: "https://www.imgacademy.com/foundation",
    },
];

export const boardingSchool: LinkItem[] = [
    {
        label: "Admissions & Tuition",
        href: "https://www.imgacademy.com/boarding-school/admissions-tuition",
    },
    {
        label: "Academics",
        href: "https://www.imgacademy.com/boarding-school/academics",
    },
    {
        label: "Personal Development",
        href: "https://www.imgacademy.com/boarding-school/personal-development",
    },
    {
        label: "College Placement",
        href: "https://www.imgacademy.com/boarding-school/college-placement",
    },
    {
        label: "Activities & Campus Life",
        href: "https://www.imgacademy.com/boarding-school/activities-campus-life",
    },
    {
        label: "Housing & Amenities",
        href: "https://www.imgacademy.com/boarding-school/housing-amenities",
    },
];

export const athleticSports: Record<"boys" | "girls", LinkItem[]> = {
    boys: [
        {
            label: "Baseball",
            href: "https://www.imgacademy.com/boarding-school/baseball",
        },
        {
            label: "Basketball",
            href: "https://www.imgacademy.com/boarding-school/basketball",
        },
        {
            label: "Football",
            href: "https://www.imgacademy.com/boarding-school/football",
        },
        {
            label: "Golf",
            href: "https://www.imgacademy.com/boarding-school/golf",
        },
        {
            label: "Lacrosse",
            href: "https://www.imgacademy.com/boarding-school/lacrosse",
        },
        {
            label: "Soccer",
            href: "https://www.imgacademy.com/boarding-school/soccer",
        },

        {
            label: "Tennis",
            href: "https://www.imgacademy.com/boarding-school/tennis",
        },
        {
            label: "Track & Field",
            href: "https://www.imgacademy.com/boarding-school/track-and-field-and-cross-country",
        },
        {
            label: "Volleyball",
            href: "https://www.imgacademy.com/boarding-school/volleyball-boys",
        },
    ],
    girls: [
        {
            label: "Basketball",
            href: "https://www.imgacademy.com/boarding-school/basketball-girls",
        },
        {
            label: "Golf",
            href: "https://www.imgacademy.com/boarding-school/golf-girls",
        },
        {
            label: "Lacrosse",
            href: "https://www.imgacademy.com/boarding-school/lacrosse-girls",
        },
        {
            label: "Soccer",
            href: "https://www.imgacademy.com/boarding-school/soccer-girls",
        },
        {
            label: "Softball",
            href: "https://www.imgacademy.com/boarding-school/softball-girls",
        },
        {
            label: "Tennis",
            href: "https://www.imgacademy.com/boarding-school/tennis-girls",
        },
        {
            label: "Track & Field",
            href: "https://www.imgacademy.com/boarding-school/track-and-field-and-cross-country-girls",
        },
        {
            label: "Volleyball",
            href: "https://www.imgacademy.com/boarding-school/volleyball-girls",
        },
    ],
};
export const sportCamps: Record<"boys" | "girls", LinkItem[]> = {
    boys: [
        {
            label: "Baseball",
            href: "https://www.imgacademy.com/sport-camps/baseball-camp",
        },
        {
            label: "Basketball",
            href: "https://www.imgacademy.com/sport-camps/basketball-camp",
        },
        {
            label: "Football",
            href: "https://www.imgacademy.com/sport-camps/football-camp",
        },
        {
            label: "Golf",
            href: "https://www.imgacademy.com/sport-camps/golf-camp",
        },
        {
            label: "Lacrosse",
            href: "https://www.imgacademy.com/sport-camps/lacrosse-camp",
        },
        {
            label: "Performance",
            href: "https://www.imgacademy.com/sport-camps/performance-camp",
        },
        {
            label: "Soccer",
            href: "https://www.imgacademy.com/sport-camps/soccer-camp",
        },

        {
            label: "Tennis",
            href: "https://www.imgacademy.com/sport-camps/tennis-camp",
        },
        {
            label: "Track & Field",
            href: "https://www.imgacademy.com/sport-camps/track-field-and-cross-country-camp",
        },
        {
            label: "Volleyball",
            href: "https://www.imgacademy.com/sport-camps/boys-volleyball-camp",
        },
    ],
    girls: [
        {
            label: "Basketball",
            href: "https://www.imgacademy.com/sport-camps/girls-basketball-camp",
        },
        {
            label: "Golf",
            href: "https://www.imgacademy.com/sport-camps/girls-golf-camp",
        },
        {
            label: "Lacrosse",
            href: "https://www.imgacademy.com/sport-camps/girls-lacrosse-camp",
        },
        {
            label: "Performance",
            href: "https://www.imgacademy.com/sport-camps/performance-camp",
        },
        {
            label: "Soccer",
            href: "https://www.imgacademy.com/sport-camps/girls-soccer-camp",
        },
        {
            label: "Softball",
            href: "https://www.imgacademy.com/sport-camps/girls-softball-camp",
        },
        {
            label: "Tennis",
            href: "https://www.imgacademy.com/sport-camps/girls-tennis-camp",
        },
        {
            label: "Track & Field",
            href: "https://www.imgacademy.com/sport-camps/girls-track-field-and-cross-country-camp",
        },
        {
            label: "Volleyball",
            href: "https://www.imgacademy.com/sport-camps/girls-volleyball-camp",
        },
    ],
};
export const otherExperiencesCamps: LinkItem[] = [
    {
        label: "Adult Tennis Camp",
        href: "https://www.imgacademy.com/adult-tennis-camp",
    },
    {
        label: "Legacy Hotel At IMG Academy",
        href: "https://www.imglegacyhotel.com",
        target: "_blank",
    },
    {
        label: "Events",
        href: "https://www.imgacademy.com/events",
    },
    {
        label: "Team Training",
        href: "https://www.imgacademy.com/team-group-corporate",
    },
    {
        label: "Group Hosting",
        href: "https://www.imgacademy.com/team-group-corporate",
    },
    {
        label: "Corporate Retreats",
        href: "https://www.imgacademy.com/team-group-corporate",
    },
    {
        label: "Golf Course",
        href: "https://imgacademygolfclub.com/",
    },
    {
        label: "Club Fittings",
        href: "https://www.imgacademy.com/accommodations-and-travel/tour-studio",
    },
    {
        label: "Prohibited Items",
        href: "https://www.imgacademy.com/prohibiteditems",
    },
    {
        label: "News",
        href: "https://www.imgacademy.com/news",
    },
];

export const developmentalCoaching: LinkItem[] = [
    {
        label: "Mental Performance Coaching",
        href: "https://plus.imgacademy.com/developmental-coaching/mental-performance",
    },
    {
        label: "Nutrition Coaching",
        href: "https://plus.imgacademy.com/developmental-coaching/nutrition",
    },
];

export const collegeRecruitingSports: Record<"mens" | "womens" | "mixed", LinkItem[]> = {
    mens: [
        {
            label: "Baseball",
            href: "/college-recruiting/colleges/baseball",
        },
        {
            label: "Basketball",
            href: "/college-recruiting/colleges/mens-basketball",
        },
        {
            label: "Diving",
            href: "/college-recruiting/colleges/mens-diving",
        },
        {
            label: "Football",
            href: "/college-recruiting/colleges/football",
        },
        {
            label: "Golf",
            href: "/college-recruiting/colleges/mens-golf",
        },
        {
            label: "Ice Hockey",
            href: "/college-recruiting/colleges/mens-ice-hockey",
        },
        {
            label: "Lacrosse",
            href: "/college-recruiting/colleges/mens-lacrosse",
        },
        {
            label: "Rowing",
            href: "/college-recruiting/colleges/mens-rowing",
        },
        {
            label: "Soccer",
            href: "/college-recruiting/colleges/mens-soccer",
        },
        {
            label: "Swimming",
            href: "/college-recruiting/colleges/mens-swimming",
        },
        {
            label: "Tennis",
            href: "/college-recruiting/colleges/mens-tennis",
        },
        {
            label: "Track",
            href: "/college-recruiting/colleges/mens-track",
        },
        {
            label: "Volleyball",
            href: "/college-recruiting/colleges/mens-volleyball",
        },
        {
            label: "Water Polo",
            href: "/college-recruiting/colleges/mens-water-polo",
        },
        {
            label: "Wrestling",
            href: "/college-recruiting/colleges/wrestling",
        },
    ],
    womens: [
        {
            label: "Basketball",
            href: "/college-recruiting/colleges/womens-basketball",
        },
        {
            label: "Beach Volleyball",
            href: "/college-recruiting/colleges/womens-beach-volleyball",
        },
        {
            label: "Diving",
            href: "/college-recruiting/colleges/womens-diving",
        },
        {
            label: "Field Hockey",
            href: "/college-recruiting/colleges/field-hockey",
        },
        {
            label: "Golf",
            href: "/college-recruiting/colleges/womens-golf",
        },
        {
            label: "Gymnastics",
            href: "/college-recruiting/colleges/womens-gymnastics",
        },
        {
            label: "Ice Hockey",
            href: "/college-recruiting/colleges/womens-ice-hockey",
        },
        {
            label: "Lacrosse",
            href: "/college-recruiting/colleges/womens-lacrosse",
        },
        {
            label: "Rowing",
            href: "/college-recruiting/colleges/womens-rowing",
        },
        {
            label: "Soccer",
            href: "/college-recruiting/colleges/womens-soccer",
        },
        {
            label: "Softball",
            href: "/college-recruiting/colleges/softball",
        },
        {
            label: "Swimming",
            href: "/college-recruiting/colleges/womens-swimming",
        },
        {
            label: "Tennis",
            href: "/college-recruiting/colleges/womens-tennis",
        },
        {
            label: "Track",
            href: "/college-recruiting/colleges/womens-track",
        },
        {
            label: "Volleyball",
            href: "/college-recruiting/colleges/womens-volleyball",
        },
        {
            label: "Water Polo",
            href: "/college-recruiting/colleges/womens-water-polo",
        },
        {
            label: "Wrestling",
            href: "/college-recruiting/colleges/womens-wrestling",
        },
    ],
    mixed: [
        {
            label: "Cheerleading",
            href: "https://plus.imgacademy.com/college-recruiting/colleges/cheerleading",
        },
    ],
};
